export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Search"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You're in Demo Mode. Balances and transactions are simulated."])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go Live Now"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nothing found"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dashboard"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["My Stores"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Information"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New Store"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Notification"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Operation History"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Support"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Counterparty Information"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AML Check"])}
}